import { combineReducers } from 'redux';

import { customInitialState, customState } from './custom';
import { shareInitialState, shareState } from './share';
import { templatesInitialState, templatesState } from './templates';

export const insightInitialState = { 
  customState: customInitialState,
  shareState: shareInitialState,
  templatesState: templatesInitialState
}

export const insightState = combineReducers({ 
  customState,
  shareState,
  templatesState
})